import * as FIELD_NAME from 'constant/form-item-names'
import * as FORM_LABEL from 'constant/form-labels'
import React from 'react'
import { Form, Input } from 'antd'
import styles from '../styles.scss'

const GroupUuidInput = () => {
  return (
    <>
      <span>{FORM_LABEL.GROUP_UUID}</span>
      <Form.Item
        name={FIELD_NAME.GROUP_UUID}
      >
        <Input
          className={styles.form_input}
          placeholder={FORM_LABEL.GROUP_UUID}
        />
      </Form.Item>
    </>
  )
}

export default GroupUuidInput
